import React, { useContext } from 'react';
// MUI
import { Box, Breadcrumbs, Button, Stack, Typography } from '@mui/material';
import { HomeOutlined, Add } from '@mui/icons-material';
import MonthYearPicker from './MonthYearPopover';
// CONTEXT
import useProductSamplingv2Context from '../context/useProductSamplingv2Context';

export default function Header() {
  const { filterForm, setFilterForm, handleCreateNewPlan } = useContext(
    useProductSamplingv2Context,
  );
  return (
    <Stack direction='row' justifyContent='space-between' alignItems='flex-start' mb={3}>
      <Box>
        <Breadcrumbs sx={{ mb: 1 }}>
          <Typography variant='body2' color='text.secondary'>
            <HomeOutlined
              sx={{
                fontSize: 15,
                mr: 0.5,
                verticalAlign: 'middle',
              }}
            />
            Plans
          </Typography>

          <Typography variant='body2' color='text.secondary'>
            Requests Overview
          </Typography>
        </Breadcrumbs>

        <Typography variant='h4' fontWeight={500}>
          Plan Requests
        </Typography>

        <Typography color='text.secondary' mt={1}>
          View, filter, and manage product sampling plans by month.
        </Typography>
      </Box>

      <Stack direction='row' spacing={2}>
        <MonthYearPicker filterForm={filterForm} setFilterForm={setFilterForm} />

        <Button
          variant='contained'
          startIcon={<Add />}
          onClick={() => handleCreateNewPlan()}
          sx={{
            bgcolor: '#2E7D32',
          }}
        >
          NEW PLAN
        </Button>
      </Stack>
    </Stack>
  );
}
